export default {
	label: 'Kaitsetarve',
	overwrite: 'Kaitsetarve manuaalne muutmine',
	bpTitle: 'Äriprotsessidest tulenev kaitsetarve ',
	main: 'Põhi',
	standard: 'Standard',
	high: 'Kõrge',
	VEITS: 'V-EITS',
	error: {
		selectAtLeastOne: 'Vali vähemalt 1 kategooria',
	},
	dialog: {
		title: 'Kinnitus',
		body1: 'Kas te olete kindel, et soovite turbeviisi muuta?',
		body2: 'See muudab rakendatavate meetmete nimekirja vastavalt valitud turbeviisile.',
	},
	category: 'Kategooriad',
}
